export class LOSJsonPath {
    losJsonPathId: string;
    fieldId: string;
    apiFieldPath: string;
    updatedDate: Date;
}
  
  